import { _t } from "../../services/TranslationService.js";

var timelineAgent;

let TimelineTableLayout = {
  render: async (game_api_id, live) => {
    if(!game_api_id) {
      return '';
    }
    let view =  /*html*/`
      <style>
        .timeline-table {
          width: 100%;
          border-collapse: collapse;
          color: #fff;
          font-size: 14px;
        }
        .timeline-table th {
          padding: 8px;
          text-align: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
        .timeline-table td {
          padding: 8px;
          text-align: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
        .timeline-table td.highlight {
          background: rgba(255, 255, 255, 0.1);
        }
        .timeline-table .time-col {
          width: 60px;
        }
        .timeline-table .match-col {
          width: 120px;
        }
        .timeline-table .score-col {
          width: 80px;
        }
        .timeline-table .corner-col,
        .timeline-table .yellow-col,
        .timeline-table .red-col {
          width: 80px;
        }
        .timeline-table tr.highlight {
          color: #ffd700;
        }
      </style>
      <div class="timeline ${live ? 'live' : ''}" game-api-id="${game_api_id}">
        <table class="timeline-table">
          <thead>
            <tr>
              <th class="time-col">${_t('Time')}</th>
              <th class="match-col">${_t('Match')}</th>
              <th class="score-col">${_t('Goal')}</th>
              <th class="corner-col">${_t('Corner')}</th>
              <th class="yellow-col">${_t('Yellow')}</th>
              <th class="red-col">${_t('Red')}</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>`;
    return view;
  },
  after_render: async (game_api_id) => {
    refreshTimelineTableLayout(game_api_id);

    if(timelineAgent) {
      clearInterval(timelineAgent);
    }
    timelineAgent = setInterval(() => {
      var $view = $('#timeline-view');
      if(!$view) {
        clearInterval(timelineAgent);
        return;
      }

      TimelineTableLayout.refreshTimeline();
    }, 3000);
  },
  on_unload: () => {
    if(timelineAgent) {
      clearInterval(timelineAgent);
    }
  },
  getTimelineForGame(game_api_id) {
    return new Promise((resolve, reject) => {
      $.getJSON(`${location.origin}/games-timeline/${game_api_id}.json`, function(items) {
        if(!items || !Array.isArray(items)) {
          reject('No data available');
          return;
        }
    
        let view = '';
        let homeGoal = 0;
        let awayGoal = 0;
        let homeCorner = 0;
        let awayCorner = 0;
        let homeYellow = 0;
        let awayYellow = 0;
        let homeRed = 0;
        let awayRed = 0;
        const rows = [];

        items.forEach(item => {
          let highlightItem = '';
          switch(item.type_id.toLowerCase()) {
            case '5': // End of the first half
              highlightItem = 'row';
              break;
            case '2': // Corner
              if (item.team === '1') {
                homeCorner++;
              } else {
                awayCorner++;
              }
              highlightItem = 'corner';
              break;
            case '4': // Yellow card
              if (item.team === '1') {
                homeYellow++;
              } else {
                awayYellow++;
              }
              highlightItem = 'yellow';
              break;
            case '3': // Red card
              if (item.team === '1') {
                homeRed++;
              } else {
                awayRed++;
              }
              highlightItem = 'red';
              break;
            case '1': // Goal
              if (item.team === '1') {
                homeGoal++;
              } else {
                awayGoal++;
              }
              highlightItem = 'goal';
              break;
            default:
              break;
          }

          rows.push(`
          <tr class="${highlightItem === 'row' ? 'highlight' : ''}">
            <td class="time-col">${item.minute.split(':')[0]}'</td>
            <td class="match-col">${_t(item.type)}</td>
            <td class="score-col ${highlightItem === 'goal' ? 'highlight' : ''}">${homeGoal} - ${awayGoal}</td>
            <td class="corner-col ${highlightItem === 'corner' ? 'highlight' : ''}">${homeCorner} - ${awayCorner}</td>
            <td class="yellow-col ${highlightItem === 'yellow' ? 'highlight' : ''}">${homeYellow} - ${awayYellow}</td>
            <td class="red-col ${highlightItem === 'red' ? 'highlight' : ''}">${homeRed} - ${awayRed}</td>
          </tr>`);
        });

        rows.reverse().forEach(row => (view += row));
        
        resolve(view);
      }, function() {
        reject('No data available');
      }).fail(function() {
        resolve('<tr><td colspan="6" style="text-align: center;">No data available</td></tr>');
      });
    });
  },
  refreshTimeline(id) {
    refreshTimeline(id);
  }
}

function refreshTimeline(id) {
  var $view = $(id ? `.timeline[game-api-id=${id}]` : '.timeline.live')
  if(!$view) {
    return;
  }

  $view.each(async function(index) {
    var game_api_id = $(this).attr('game-api-id');
    var content = await TimelineTableLayout.getTimelineForGame(game_api_id);
    $(this).find('tbody').html(content);
  });
}

export default TimelineTableLayout;
